import createPlatformAuthorizer from './internal/PlatformAuthorizerImpl';
import { makeAuthorizedHttpCall } from './internal/AuthorizedHttpCall';
import { PlatformAuthorizer } from './PlatformAuthorizer';
import { PlatformConfig } from './PlatformConfig';
import { UserAuthorizationData, UserAuthorizationDelegate } from './UserAuthorization';
import { OAuthService } from './OAuth2/OAuthService';
import { PlatformErrorCodes } from './PlatformErrorCodes';
import { AuthorizationData } from './OAuth2/model/AuthorizationData';
import { PlatformHeader, PlatformError, PlatformResponse } from './modal/PlatformResponse';
import { AuthorizationUtil } from './AuthorizationUtil';
import { createPlatformClient } from './internal/PlatformClientImpl';
import { PlatformClient } from './PlatformClient';
import { Extensions } from './PlatformExtensions';
import { PlatformExtensions } from './internal/PlatformExtensionsImpl';
import { GeoLocation } from './modal/GeoLocationResponse';
import { AdobePrimetimeToken } from './modal/AdobePrimeTokenResponse';

const version = '__buildVersion__';

export {
  createPlatformAuthorizer,
  PlatformAuthorizer,
  PlatformConfig,
  UserAuthorizationData,
  UserAuthorizationDelegate,
  OAuthService,
  makeAuthorizedHttpCall,
  PlatformErrorCodes,
  AuthorizationData,
  PlatformHeader,
  PlatformError,
  PlatformResponse,
  AuthorizationUtil,
  createPlatformClient,
  PlatformClient,
  version,
  Extensions,
  PlatformExtensions,
  GeoLocation,
  AdobePrimetimeToken,
};
